module.exports = __webpack_public_path__ + "static/media/by2.c1ace5dc.svg";